function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.753 19.803h64.632l16.817 16.158v16.158h-81.45z",
    style: {
      fill: "#2b471f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.635 51.546h80.121v60.264h-80.12z",
    style: {
      fill: "#508139"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.711 5v.019H15.28V123.39h99.737v-84.23h-.143L80.806 5.096v-.076h-.076zM30.383 24.798H80.71v14.48H99.61v10.715H30.383zm40.264 31.25H99.24v6.29H70.647zm0 11.269h28.727v6.256H70.647zm0 11.235h28.727v6.324H70.647zM30.854 89.854h68.52v6.29h-68.52zm0 11.235h27.314v6.358H30.854z",
    style: {
      fill: "#8ac072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.854 55.805h35.019V84.74h-35.02z",
    style: {
      fill: "#f2f8ef"
    }
  }));
};
export default SvgIcon;